import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/down.svg'


const _hoisted_1 = { class: "w-full relative flex" }
const _hoisted_2 = ["onClick"]

import { ref, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'drop-down',
  props: {
  options: {
    type: Array,
    default: () => [],
  },
  mode: {
    type: String,
    default: "normal",
  },
},
  emits: ["input"],
  setup(__props, { emit: __emit }) {

const props = __props;
const options = computed(() => {
  return props.options;
});
const emit = __emit;
const isDropdownOpen = ref(false);
const openDropdown = () => {
  isDropdownOpen.value = true;
};
const closeDropdown = () => {
  setTimeout(() => {
    isDropdownOpen.value = false;
  }, 200);
};
const selectOption = (option: string) => {
  emit("input", option);
  closeDropdown();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      readonly: "",
      onFocus: openDropdown,
      onBlur: closeDropdown,
      class: "border border-solid border-[#5e9822] py-3 px-5 text-sm w-full bg-transparent outline-none"
    }), null, 16),
    _createElementVNode("img", {
      src: _imports_0,
      class: _normalizeClass(["absolute right-5 top-4 transition-all", { 'rotate-180': isDropdownOpen.value }])
    }, null, 2),
    _withDirectives(_createElementVNode("ul", {
      class: _normalizeClass(["absolute top-12 left-0 right-0 z-50 w-full border border-solid border-[#5e9822]", {
        'bg-white': __props.mode === 'normal',
        'bg-[#333333]': __props.mode === 'dark',
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          onClick: ($event: any) => (selectOption(option as string)),
          class: _normalizeClass(["py-2 px-4 cursor-pointer hover:bg-gray-100 transition-all text-sm", {
          'hover:bg-gray-100 text-primary-gray': __props.mode === 'normal',
          'hover:bg-gray-500': __props.mode === 'dark',
        }])
        }, _toDisplayString(option), 11, _hoisted_2))
      }), 128))
    ], 2), [
      [_vShow, isDropdownOpen.value]
    ])
  ]))
}
}

})